import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_mask = _resolveDirective("mask")

  return _withDirectives((_openBlock(), _createElementBlock("input", {
    type: "text",
    class: "ym-disable-keys",
    value: $data.display,
    onInput: _cache[0] || (_cache[0] = (...args) => ($options.onInput && $options.onInput(...args)))
  }, null, 40, _hoisted_1)), [
    [_directive_mask, $options.config]
  ])
}